import { BlockedTenantRecordDTO } from '@reposit/api-client';
import { lowerCase, startCase } from 'lodash';
import moment from 'moment';

export interface BlockedTenantBannerRow {
  label: string;
  value: string;
  userId?: string;
}

export function buildBlockedTenantBannerRows(blockedTenant: BlockedTenantRecordDTO): BlockedTenantBannerRow[] {
  const rows: BlockedTenantBannerRow[] = [{ label: 'Reason', value: startCase(lowerCase(blockedTenant.reason)) }];

  if (blockedTenant.notes) {
    rows.push({ label: 'Notes', value: blockedTenant.notes });
  }

  if (blockedTenant.actionedByUserId) {
    rows.push({ label: 'Blocked by', value: `User #${blockedTenant.actionedByUserId}`, userId: blockedTenant.actionedByUserId });
  }

  rows.push({ label: 'Blocked on', value: moment(blockedTenant.createdAt).format('DD/MM/YYYY') });

  if (blockedTenant.integratorId) {
    rows.push({ label: 'Integrator', value: blockedTenant.integratorId });
  }

  return rows;
}
